module.exports = __webpack_public_path__ + "static/media/BeeTract_Home1.bf0ccc56.png";